// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zidU","colMin":"styles_colMin__2shLL"};